import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Input, Modal, Spin, useAlert } from './ui';
import axios from 'axios';
import datas from "../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../Functions/Security/Crypter';
import { useNavigate } from 'react-router-dom';
import { useAuthHeader } from 'react-auth-kit';


const extensiosValide = 'image/*, video/*, .pdf, .avi';

export default function Updatetext(props: { Mobile?: string, Name?: string, label?: string, title?: string, isButton?: true }) {
  const [open, setOpen] = React.useState(false);
  // USER TOKEN
  const authHeader = useAuthHeader()
  const alert = useAlert()

  const navigat = useNavigate()
  const { register, handleSubmit, setValue, reset, getValues } = useForm()
  const [fichier, setFicher] = useState<File>()
  const [isOk, setIsOk] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [codeU, setCodeU] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [Mobile, setMobile] = useState("")

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit_verif = () => {
    setLoading(true)
    var data = { "codeU": codeU, "Email": email }
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: env.API_BASE_URL + datas.API_LINKs.VerfifMail,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
      },
      data: Crypter.encrypt(JSON.stringify(data))
    };

    axios.request(config)
      .then((response) => {
        setLoading(false)
        let res = JSON.parse(Crypter.decrypt(response.data)).Value
        if (res.StatutCode == 200) {
          setOpen(false)

          reset()

          localStorage.setItem("verif_otp", "1")
          localStorage.setItem(datas.user, Crypter.encrypt(JSON.stringify(res.Result)))
          localStorage.setItem("CodeU", Crypter.encrypt(codeU))
          navigat("/OTP_Verification")
        } else {
          alert.warning(res.Message)
        }
      })
      .catch((error) => {
        setLoading(false)
        alert.error(error.message)
      });
  }

  return (
    <div>
      <Button variant="ghost" size="sm" onClick={handleClickOpen}>
        {props.label}
      </Button>
      <Modal open={open} onClose={handleClose} title="Récupération de mot de codeUe" width={560}>
        <Spin spinning={loading}>
          <form onSubmit={handleSubmit(onSubmit_verif)}>
            <div className='round0'>{/*className='round0'*/}
              <div className='ressource'>
                <div className="flex gap-3">
                  <Input
                    onChange={(e) => { setCodeU(e.target.value) }}
                    required
                    type='text'
                    label='Code utilisateur'
                    placeholder="Entrez votre code utilisateur" />
                  <Input
                    onChange={(e) => { setEmail(e.target.value) }}
                    required
                    type='email'
                    label='Adresse mail'
                    placeholder="Entrer votre adresse mail" />
                </div>
                <br /><br />
                <div className="flex gap-2">
                  <Button variant="outline" className="text-red-600 border-red-300 hover:bg-red-50" onClick={() => { setOpen(false) }}>Anuller</Button>
                  <Button className="w-full" variant="secondary" onClick={onSubmit_verif}>Récupérer</Button>
                </div>
              </div>
            </div>
          </form>
        </Spin>
      </Modal>
    </div>
  );
}
